import React from 'react';
import Svg from '../shared/Svg';
import './TimeRecordError.scss';

export const TimeRecordError = () => {
  return (
    <div className={`timeRecordError-container`}>
      <Svg className='timeRecordError-image' data='/assets/error.svg' fill='#C23934'/>
      <div className='timeRecordError-details'>
        <p className='timeRecordError-text'>Error loading time records associated with this email.</p>
      </div>
    </div>
  );
};
